module.exports = __webpack_public_path__ + "static/kofi-33767062a843b82686b66dfb5751a4bd.png";